export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '上海诠感科技',

    /** 公司名称 */
    name: '上海诠感科技有限公司',
    /** 公司微信 */
    wechat: 'jfewojfw',
    /** 公司邮箱 */
    email: 'wangchuanli@quangan-tech.com',
    /** 公司手机 */
    phone: '13795409005',
    /** 公司电话 */
    tel: '021-87285856',
    /** 公司地址 */
    address: '上海市青浦区华新镇华腾路1288号',
    /** 备案号 */
    keepOnRecordIcp: '沪ICP备2021020648号',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.222996,
        latitude: 31.242636,
        title: '上海华新工业园区',
        address: '上海市青浦区华新镇华腾路1288号'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js